<ui-popup-layout>
  <ui-popup-body>
    <div #container class="tw-mt-2">
      <div class="tw-flex tw-items-center tw-gap-2">
        <img class="tw-rounded-md tw-w-6 tw-h-6 tw-text-xl" [src]="icon$ | async"/>
        <h2 class="tw-font-medium tw-text-2xl">{{ extensionNameFriendly$ | async }}</h2>
      </div>
      <p class="tw-pt-2 tw-pb-3 tw-text-base-text/60">{{ description$ | async }}</p>
      <button *ngIf="isSignedId$ | async" kendoButton class="tw-flex tw-ml-auto tw-mt-4" type="submit" themeColor="secondary" (click)="signOut()">
        <span class="tw-flex tw-items-center">
          <span class="tw-mr-2" translate>dashboard.empty.actions.sign_out</span>
        </span>
      </button>
    </div>
  </ui-popup-body>
</ui-popup-layout>
